import Api from 'services/Api';

export const get = ({ appId }) => {
  return Api.query(
    `query ($app_id: String!){
      app(id: $app_id) {
        id
        name
        users(limit: 50, order: desc) {
          slice {
            id
            ... on User {
              external_id
            }
            created_at
            event_history(latest: "14_day") {
              start
              end
              type
            }
          }
        }
      }
    }`,
    {
      app_id: appId,
    }
  );
};

export const getWithId = ({ id }) => {
  return Api.query(
    `query ($user_id: String!){
      user(id: $user_id) {
        id
        ... on User {
          external_id
        }
        created_at
        event_history(latest: "14_day") {
          start
          end
          type
        }
      }
    }`,
    {
      user_id: id,
    }
  );
};

export const getWithExternalId = ({ externalId, appId }) => {
  return Api.query(
    `query ($external_id: String!, $app_id: String!){
      user(external_id: $external_id, application_id: $app_id) {
        id
        ... on User {
          external_id
        }
        created_at
        event_history(latest: "14_day") {
          start
          end
          type
        }
      }
    }`,
    {
      external_id: externalId,
      app_id: appId,
    }
  );
};
